import { render, staticRenderFns } from "./customers.vue?vue&type=template&id=0d906a22&scoped=true"
import script from "./customers.vue?vue&type=script&lang=js"
export * from "./customers.vue?vue&type=script&lang=js"
import style0 from "./customers.vue?vue&type=style&index=0&id=0d906a22&prod&lang=css"
import style1 from "./customers.vue?vue&type=style&index=1&id=0d906a22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d906a22",
  null
  
)

export default component.exports